export function getCurrency(currency: string | null) {
  return currency === 'USD' ? '$' : '€';
}
